"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _icons = _interopRequireDefault(require("./icons"));

var _Icon = _interopRequireDefault(require("./Icon.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var IconWrapper = (0, _styledComponents.default)(function (_ref) {
  var type = _ref.type,
      className = _ref.className,
      children = _ref.children,
      tabIndex = _ref.tabIndex,
      fontsize = _ref.fontsize,
      color = _ref.color,
      customProperties = _ref.customProperties,
      backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      padding = _ref.padding;
  var Renderable = type in _icons.default ? _icons.default[type] : _icons.default.FlightIcon;
  return /*#__PURE__*/_react.default.createElement(Renderable, (0, _extends2.default)({
    className: className,
    tabIndex: tabIndex,
    fontsize: fontsize,
    themeColor: color,
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    padding: padding
  }, customProperties), children);
}).withConfig({
  displayName: "Icon__IconWrapper",
  componentId: "sc-k1wgnq-0"
})(["display:block;outline:none;height:1em;width:1em;fill:currentColor;font-size:", " !important;color:", ";background-color:", ";border-radius:", ";padding:", ";;"], function (props) {
  return props.fontsize && props.theme.fontSize ? props.theme.fontSize[props.fontsize] : props.theme.fontSize.normal;
}, function (props) {
  return props.color && props.theme.colors ? props.theme.colors[props.color] : props.theme.colors.neutral;
}, function (_ref2) {
  var backgroundColor = _ref2.backgroundColor;
  return backgroundColor || 'none';
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius || '0';
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding || '0';
});

var getIconName = function getIconName(icon) {
  return icon in _icons.default ? _icons.default[icon] : null;
};

var Icon = function Icon(props) {
  // const { icon } = props;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var children = props.children,
      theme = props.theme,
      fontsize = props.fontsize,
      color = props.color,
      icon = props.icon,
      customProperties = props.customProperties,
      accessible = props.accessible,
      className = props.className,
      backgroundColor = props.backgroundColor,
      borderRadius = props.borderRadius,
      padding = props.padding;
  var tabIndex = !accessible ? '-1' : '0'; // const getIcon = (propObj) => {

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(IconWrapper, {
      type: icon,
      fontsize: fontsize,
      color: color,
      className: className,
      customProperties: customProperties,
      tabIndex: tabIndex,
      theme: themeContext,
      backgroundColor: backgroundColor,
      borderRadius: borderRadius,
      padding: padding
    }, children);
  }; // return ;
  // };


  var AirasiaIcon = getIconName(icon);

  if (AirasiaIcon) {
    return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
      theme: theme
    }, getMain());
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

Icon.propTypes = _Icon.default.PropTypes;
Icon.defaultProps = _Icon.default.DefaultProps;
var _default = Icon;
exports.default = _default;